/* The shop's people list.
 *
 * Office only — the server answers 403 to anyone else, so nothing here needs to
 * ask. Adding someone by hand creates the account and the membership in one
 * call; there is still no public signup (IDEA.md §9). */
import type {
  CreatePersonRequest,
  CreatePersonResponse,
  PersonDto,
  ResetPasswordRequest,
  UpdatePersonRequest,
} from '@oneshot2pac/shared';
import { api } from './client';

export const peopleApi = {
  list: () => api.get<PersonDto[]>('/people'),

  create: (body: CreatePersonRequest) => api.post<CreatePersonResponse>('/people', body),

  /** Send only what changed: role, money access, name, or whether they are
   *  still in the shop. */
  update: (id: string, body: UpdatePersonRequest) => api.patch<PersonDto>(`/people/${id}`, body),

  /** Set someone's password for them, because there is no mailer and no reset
   *  link: the office types one and says it out loud. It answers with the
   *  person, never with the password. */
  resetPassword: (id: string, password: string) =>
    api.post<PersonDto>(`/people/${id}/password`, { password } satisfies ResetPasswordRequest),
};
